import styled from 'styled-components'

export default styled.div`
  display: inline-block;
  color: #016558;
`
